module.exports = __webpack_public_path__ + "img/engelstrompete_6.1a492213.jpg";